module.exports = __webpack_public_path__ + "static/media/benefits_insurance.3f456e98.svg";